/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespLocationsModule_homepage = {
    readonly locationsModule: {
        readonly title?: string | null;
        readonly subtitle?: string | null;
        readonly location?: {
            readonly title: string | null;
            readonly imageUrl: string | null;
            readonly items: ReadonlyArray<{
                readonly cmsId: number | null;
                readonly title: string | null;
                readonly linkData: {
                    readonly path: string | null;
                    readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
                };
            } | null> | null;
        } | null;
        readonly items?: ReadonlyArray<{
            readonly cmsId: number | null;
            readonly title: string | null;
            readonly imageUrl: string | null;
            readonly linkData: {
                readonly path: string | null;
                readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
            };
        } | null> | null;
    } | null;
    readonly " $refType": "HpRespLocationsModule_homepage";
};
export type HpRespLocationsModule_homepage$data = HpRespLocationsModule_homepage;
export type HpRespLocationsModule_homepage$key = {
    readonly " $data"?: HpRespLocationsModule_homepage$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespLocationsModule_homepage">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "imageUrl",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cmsId",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "linkData",
  "storageKey": null,
  "args": null,
  "concreteType": "LinkData",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SeoLink_linkData",
      "args": null
    }
  ]
};
return {
  "kind": "Fragment",
  "name": "HpRespLocationsModule_homepage",
  "type": "Homepage",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "locationsModule",
      "name": "module",
      "storageKey": "module(type:\"locations\")",
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "locations"
        }
      ],
      "concreteType": null,
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "type": "LocationsModule",
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "subtitle",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "location",
              "storageKey": null,
              "args": null,
              "concreteType": "Location",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "items",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "LocationItem",
                  "plural": true,
                  "selections": [
                    (v2/*: any*/),
                    (v0/*: any*/),
                    (v3/*: any*/)
                  ]
                }
              ]
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "items",
              "storageKey": null,
              "args": null,
              "concreteType": "Product",
              "plural": true,
              "selections": [
                (v2/*: any*/),
                (v0/*: any*/),
                (v1/*: any*/),
                (v3/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = '438fd2091320d1f5596c7cf792307a62';
export default node;
